module.exports = __webpack_public_path__ + "img/banner5.d276af9f.png";